import React, { FC } from 'react'
import styled from 'styled-components'
import { PaddedContentStyled, DescriptionTextStyled, SecondaryHeaderStyled } from '../../styles/shared'
import TextWithLinkStyled from '../common/textWithLinkStyled'
import { ScreenBreakpointSize } from '../../utils/enums'
import { getScreenBreakpointSize } from '../../utils/getScreenBreakpointSize'
import { StaticImage } from 'gatsby-plugin-image'

const ContainerStyled = styled.div`
  background: var(--background-gray);
  border: 1px solid var(--border-gray);
  border-radius: var(--border-radius-8);
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: var(--spacing-32) auto 0;
  max-width: var(--page-title-max-width);
  text-align: center;
  overflow: hidden;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Medium, -1)}) {
    border-radius: 0;
    border-right: none;
    border-left: none;
    align-items: flex-start;
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    align-items: flex-start;
  }
`
const CustomSectionTitleStyled = styled(SecondaryHeaderStyled)`
  margin-top: var(--spacing-32);
  margin-bottom: var(--spacing-16);
  align-self: center;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    padding-left: var(--spacing-16);
  }
`
const CustomDescriptionTextStyled = styled(DescriptionTextStyled)`
  max-width: 72%;
  margin-left: auto;
  margin-right: auto;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
    max-width: 95%;
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    padding: 0 var(--spacing-32);
    max-width: 95%;
  }
`
const LinkContainerStyled = styled.div`
  margin-top: var(--spacing-16);
  margin-bottom: var(--spacing-32);
  align-self: center;

  @media screen and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.Large, -1)}) {
    padding-left: var(--spacing-16);
    padding-right: var(--spacing-16);
  }

  @media screen and (min-width: ${getScreenBreakpointSize(
      ScreenBreakpointSize.Large,
    )}) and (max-width: ${getScreenBreakpointSize(ScreenBreakpointSize.ExtraLarge)}) {
    padding-left: var(--spacing-16);
  }
`

const Hashtag = styled.div`
  background-color: #f7f7f7;
  border-radius: 3px;
  border: 1px solid var(--border-gray);
  color: var(--color-blue);
  font-weight: bold;
  font-size: 0.7rem;
  overflow: auto;
  padding: 3px 5px;
  margin-left: 2px;
  margin-right: 2px;
  display: inline-block;
  vertical-align: middle;
`

const ProtectYourself: FC = () => {
  return (
    <PaddedContentStyled className="mb-[34px]">
      <ContainerStyled>
        <StaticImage src={'../../assets/images/encryption-graphic.jpg'} alt="Encryption Graphic" />
        <CustomSectionTitleStyled>Take back your data.</CustomSectionTitleStyled>
        <CustomDescriptionTextStyled>
          Shape-shifting privacy policies and unauthorized access by <Hashtag>#BigTech</Hashtag> and other non-encrypted
          services can lead to leaks, doxing, financial fraud, identity theft, loss of control over your information,
          and other existential harms to you or your business. Safeguard your private data with{' '}
          <strong>zero-knowledge encryption</strong> and open, <strong>audited applications</strong> by Standard Notes.
        </CustomDescriptionTextStyled>
        <LinkContainerStyled>
          <TextWithLinkStyled
            text={'Read our security audits'}
            targetUrl={'/help/2/has-standard-notes-completed-a-third-party-security-audit'}
          />
        </LinkContainerStyled>
      </ContainerStyled>
    </PaddedContentStyled>
  )
}

export default ProtectYourself
